import TickerPrice from './TickerPrice.jsx';

export default TickerPrice;